import { API_BASE, authFetch, readJson } from "./base";

// ── Life-area read shape (subset) ────────────────────────────────
// Mirrors backend LifeAreaResponse. We don't import the full response model
// here to keep this file decoupled from projection-types.

export interface LifeAreaItem {
  id: string;
  area: string;
  label: string;
  emoji: string;
  satisfaction: number;
  focus_level: string;
  focus_score: number;
  goal_count: number;
  avg_progress: number;
  /** User-set weekly minute commitment. NULL = use computed default. */
  target_minutes_per_week: number | null;
}

export interface LifeAreaListResponse {
  areas: LifeAreaItem[];
}

export async function getLifeAreas(): Promise<LifeAreaListResponse> {
  const response = await authFetch(`${API_BASE}/life-areas`);
  return readJson<LifeAreaListResponse>(response, "Failed to load life areas");
}

// ── PATCH /api/life-areas/batch ─────────────────────────────────
// Atomic multi-area update. Either all areas update or none. (FR-2, AC-17)

export interface LifeAreaBatchPatchItem {
  id: string;
  /** null clears (use computed default); 0 is preserved as a 'do not schedule' commitment (FR-18). */
  target_minutes_per_week: number | null;
}

export async function patchLifeAreasBatch(
  updates: LifeAreaBatchPatchItem[]
): Promise<LifeAreaListResponse> {
  const response = await authFetch(`${API_BASE}/life-areas/batch`, {
    method: "PATCH",
    body: JSON.stringify({ areas: updates }),
  });
  return readJson<LifeAreaListResponse>(
    response,
    "Failed to save balance commitments"
  );
}

/**
 * Build the life_area_commits payload for `POST /api/schedule/generate`.
 *
 * Forwards 0 verbatim — never filtered. NULL/undefined values are dropped
 * (means "no opinion; use computed default"). FR-18 explicit contract.
 */
export function deriveLifeAreaCommits(
  areas: LifeAreaItem[]
): Record<string, number> {
  const commits: Record<string, number> = {};
  for (const a of areas) {
    if (a.target_minutes_per_week !== null && a.target_minutes_per_week !== undefined) {
      commits[a.area] = a.target_minutes_per_week;
    }
  }
  return commits;
}
